<template>
  <b-modal
    id="registration-success-modal"
    size="lg"
    @hide="hideModal"
    hide-header
    hide-footer
    centered
    modal-class="registration-success-modal text-center"
  >
    <p>
      <b>Registration complete!</b> <br />
      An email will be sent to {{ email }}, after verification.
    </p>
  </b-modal>
</template>

<script>
export default {
  name: "register-success-modal",
  props: {
    email: String
  },
  methods: {
    hideModal() {
      this.$router.push("/");
    }
  }
};
</script>

<style></style>
